import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { Observable } from 'rxjs';
import { Cacheable } from 'ts-cacheable';
import { CACHE_KEYS } from 'src/app/helpers/Cache';

@Injectable({
  providedIn: 'root'
})

export class LevelsService {

  constructor(private api: ApiService) {
  }

  // maxAge 12 hours
  @Cacheable({ cacheKey: CACHE_KEYS.levels, maxAge: 12 * 60 * 60 * 1000 })
  public get(level_id, params?): Observable<any> {
    return this.api.get(`/levels/${level_id}`, { params });
  }

}
